var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#notes_svg__clip0_1627_4222)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.374 2.467l-1.524-.02.005-.305a.898.898 0 00-.903-.926.898.898 0 00-.926.902l-.004.304-1.524-.02-.637 2.125 6.094.08-.58-2.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.675 2.775l1.828.024a.898.898 0 01.902.927l-.137 10.36a.898.898 0 01-.926.903L3.2 14.868a.898.898 0 01-.902-.926L2.435 3.58a.898.898 0 01.926-.902l1.828.024"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "notes_svg__clip0_1627_4222"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgNotes;